module.exports = __webpack_public_path__ + "jp.svg?28157b5298df82905d87061bfe56788c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/jp.svg
// module id = 1436
// module chunks = 0